// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3UuVz","modalForm":"UpgradeEpcsModal_modalForm__2mVtX","modalFooter":"UpgradeEpcsModal_modalFooter__4cEV9"};